module.exports = __webpack_public_path__ + "static/media/Payment_Bank.b6bfa44b.png";